import api from "./axios";

export const loginPhoneOTP = async (data) => {
    try {
        const response = await api.post(`/api/v1/user/login/otp`, data);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const loginPhone = async (data) => {
    try {
        const response = await api.post(`/api/v1/user/login`, data);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const loginEmailOTP = async (data) => {
    try {
        const response = await api.post(`/api/v1/user/login/email-otp`, data);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const loginEmail = async (data) => {
    try {
        const response = await api.post(`/api/v1/user/login/email`, data);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getVerifyToken = async (token) => {
    try {
        const response = await api.get(`/api/v1/user/verify/${token}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const sendVerificationEmail = async () => {
    try {
        const response = await api.post(`/api/v1/user/verify`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const checkEmailVerification = async () => {
    try {
        const response = await api.get(`/api/v1/user/check-email-verification`);
        return response.data;
    } catch (error) {
        return error;
    }
}